/** True si fechaAlta está dentro de los últimos `minutes` minutos. */
export function isRecentlyCreated(fechaAlta?: string | null, minutes = 10): boolean {
  if (!fechaAlta) return false;
  const t = new Date(fechaAlta).getTime();
  if (Number.isNaN(t)) return false;
  return Date.now() - t < minutes * 60 * 1000;
}

export function initialsFromName(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}
